import { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
  ErrorDiv,
  Button,
  DetailsDiv,
  NetworkErrorPopup,
  CustomBtn,
  Retry,
  NetworkErrorTitleContainer
} from './styled-components'

const ErrorPopup = ({
  onClosePopup,
  noDiv,
  error,
  netWorkErrorCustomTitle = <FormattedMessage id="conection_error_title" />,
  networkErrorCustomMessage = (
    <FormattedMessage id="conection_error_description" />
  ),
  newtworkErrorCustomButtons = []
}) => {
  const [showDetails, setShowDetails] = useState(false)
  const [popupClosed, setPopupClosed] = useState(false)

  const closePopup = useCallback(() => {
    if (onClosePopup) onClosePopup()
    setPopupClosed(true)
  }, [onClosePopup])

  let { name, message, response, onRetry } = error

  name = name || 'Error'
  message = typeof error === 'string' ? error : message

  const type =
    message === 'Network Error' ? 'network' : response ? 'response' : undefined

  const handleNetworkErrorCustomButtonClick = (button) => {
    closePopup()
    button.onClick()
  }

  if (popupClosed) return null

  const content = (
    <>
      {type === 'network' && (
        <NetworkErrorPopup>
          <NetworkErrorTitleContainer>
            {netWorkErrorCustomTitle}
          </NetworkErrorTitleContainer>

          <p>{networkErrorCustomMessage}</p>

          <div className="footer">
            {newtworkErrorCustomButtons?.length ? (
              newtworkErrorCustomButtons.map((button, index) => (
                <CustomBtn
                  key={`custom-popup-button-${index}`}
                  onClick={() => handleNetworkErrorCustomButtonClick(button)}
                >
                  <FormattedMessage id={button.text} />
                </CustomBtn>
              ))
            ) : (
              <>
                <CustomBtn onClick={() => location.reload()}>
                  <FormattedMessage id="refreshPage" />
                </CustomBtn>
                <CustomBtn onClick={closePopup}>
                  <FormattedMessage id="close" />
                </CustomBtn>
              </>
            )}
          </div>
        </NetworkErrorPopup>
      )}

      {type === 'response' && (
        <span>
          <h3>
            <FormattedMessage id="error_default" />
          </h3>
          <p>
            {!!response?.data?.error_description && (
              <span>{response.data.error_description}</span>
            )}
            {onRetry && (
              <Retry onClick={onRetry}>
                <span>&nbsp;</span>
                <FormattedMessage id="try_again" />
              </Retry>
            )}
          </p>
        </span>
      )}

      {!type && (
        <span>
          <h3>
            <FormattedMessage id="error_default" />
          </h3>
          <Button onClick={() => setShowDetails((prev) => !prev)}>
            <FormattedMessage id="error_defaultDetails" />
          </Button>
          {showDetails && (
            <DetailsDiv>
              <h4>{name}</h4>
              <p>{message}</p>
            </DetailsDiv>
          )}
        </span>
      )}
    </>
  )

  return noDiv ? content : <ErrorDiv>{content}</ErrorDiv>
}

ErrorPopup.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.string.isRequired
  ]),
  noDiv: PropTypes.bool,
  onClosePopup: PropTypes.func
}

export default ErrorPopup
